/**
 * Login Form - Prevent Scroll Jump
 *
 * Previne scroll automático quando clica em links #recover e #login
 * Mantém hash na URL para CSS :target funcionar
 */

(function() {
  'use strict';

  // Prevenir scroll em links de troca de formulário
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href="#recover"], a[href="#login"]');

    if (link) {
      e.preventDefault();
      e.stopPropagation();

      // Salva posição atual do scroll
      const scrollY = window.scrollY;
      const hash = link.getAttribute('href');

      // Congela scroll temporariamente (previne qualquer movimento)
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';

      // Usa requestAnimationFrame para garantir que o hash mude DEPOIS do freeze
      requestAnimationFrame(() => {
        // Atualiza hash (dispara :target CSS mas SEM scroll porque body está fixed)
        window.location.hash = hash;

        // Aguarda próximo frame para descongela
        requestAnimationFrame(() => {
          // Descongela e restaura posição
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          document.body.style.overflow = '';
          window.scrollTo(0, scrollY);
        });
      });
    }
  });

  // Prevenir scroll também no evento hashchange (fallback)
  let preventScroll = false;

  window.addEventListener('hashchange', function() {
    if (preventScroll) {
      window.scrollTo(0, 0);
      preventScroll = false;
    }
  });
})();
